import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_TITLE = '7/24 Lastik Yol Yardım';
const BASE_DESC = "Kocaeli lastik yol yardım. En yakın lastikçi 7/24 acil mobil lastik tamiri, değişimi ve yol yardım hizmeti. İzmit, Gebze, Körfez, Darıca, Derince ve tüm ilçelere ortalama 30 dakikada geliyoruz. Hemen arayın: 0534 968 7611";

const PAGE_SEO = {
  '/': {
    title: 'Kocaeli Lastik Yol Yardım | En Yakın Lastikçi 7/24 Acil Mobil Lastikçi',
    desc: BASE_DESC,
    keywords: 'kocaeli lastik yol yardım, en yakın lastikçi, mobil lastikçi kocaeli, izmit lastikçi, gebze lastik değişimi, 7/24 lastikçi, acil lastik tamiri, oto lastik yol yardım, lastikçi ara, kocaeli mobil lastikçi, lastik tamiri en yakın, körfez lastikçi, darıca lastikçi, derince lastikçi',
  },
  '/acil-yol-yardim': {
    title: 'Acil Lastik Yol Yardım Kocaeli | 7/24 Mobil Lastik Servisi',
    desc: 'Kocaeli genelinde 7/24 acil lastik yol yardım. Lastiğiniz patladıysa hemen arayın. İzmit, Gebze, Körfez, Darıca — ortalama 30 dakikada yanınızdayız.',
  },
  '/garanti': {
    title: 'Lastik Garanti Hizmeti | 24 Ay Garanti — 7/24 Lastik Kocaeli',
    desc: 'Yaptığımız tüm lastik işlemlerine 24 ay garanti. Kocaeli genelinde güvenilir lastik tamiri ve değişimi. Patlama, çivi, işçilik hatası dahil.',
  },
  '/markalarimiz': {
    title: 'Lastik Markaları | Goodyear, Michelin, Bridgestone — 7/24 Lastik',
    desc: 'Goodyear, Lassa, Pirelli, Bridgestone, Michelin, Continental, Petlas — Kocaeli genelinde orijinal lastik servisi.',
  },
  '/blog': {
    title: 'Lastik Blog | Bakım İpuçları, Güvenlik Rehberi — 7/24 Lastik',
    desc: 'Lastik bakımı, güvenli sürüş, lastik basıncı ve yol yardım hakkında uzman rehber yazıları. Kocaeli sürücüleri için.',
  },
  '/iletisim': {
    title: 'İletişim | 7/24 Lastik Yol Yardım Kocaeli — Hemen Ara',
    desc: 'Kocaeli lastik yol yardım iletişim. 3 aktif hat, WhatsApp, e-posta. 7/24 kesintisiz hizmet. Hemen arayın: 0534 968 7611.',
  },
  '/hakkimizda': {
    title: 'Hakkımızda | 7/24 Lastik — Kocaeli Acil Yol Yardım',
    desc: "2017'den beri Kocaeli genelinde 7/24 lastik yol yardım hizmeti. 12+ ilçe, sertifikalı ekip, 24 ay garanti.",
  },
  '/vizyonumuz': {
    title: 'Vizyonumuz | 7/24 Lastik Kocaeli',
    desc: "Kocaeli ve çevre illerde en güvenilir lastik yol yardım markası olmak.",
  },
  '/misyonumuz': {
    title: 'Misyonumuz | 7/24 Lastik Kocaeli',
    desc: "Yolda kalan her sürücüye en kısa sürede ulaşmak, yerinde kaliteli tamir hizmeti sunmak.",
  },
};

export function SEOHead({ path, title, description, article, image }) {
  const seo = PAGE_SEO[path] || {};
  const pageTitle = title || seo.title || `${BASE_TITLE} | Kocaeli Mobil Lastikçi`;
  const pageDesc = description || seo.desc || BASE_DESC;
  const pageKeywords = seo.keywords || 'kocaeli lastik yol yardım, en yakın lastikçi, mobil lastikçi kocaeli, izmit lastikçi, gebze lastik değişimi, 7/24 lastikçi, acil lastik tamiri, oto lastik yol yardım, lastikçi ara, körfez lastikçi, darıca lastikçi, derince lastikçi, lastik tamiri en yakın';
  const url = `https://724lastik.com.tr${path || '/'}`;
  const ogImage = image || 'https://724lastik.com.tr/images/hero/slide1.webp';

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content={pageKeywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:site_name" content="7/24 Lastik" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Geo */}
      <meta name="geo.region" content="TR-41" />
      <meta name="geo.placename" content="Kocaeli" />

      {/* Language & Alternate */}
      <link rel="alternate" hrefLang="tr" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
    </Helmet>
  );
}

export function BlogSEOHead({ post }) {
  if (!post) return null;
  const url = `https://724lastik.com.tr/blog/${post.slug}`;
  const fullImage = post.image.startsWith('http') ? post.image : `https://724lastik.com.tr${post.image}`;

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": post.title,
    "description": post.excerpt,
    "image": fullImage,
    "datePublished": post.date,
    "dateModified": post.date,
    "url": url,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url,
    },
    "author": {
      "@type": "Organization",
      "name": "7/24 Lastik",
      "url": "https://724lastik.com.tr",
    },
    "publisher": {
      "@type": "Organization",
      "name": "7/24 Lastik",
      "url": "https://724lastik.com.tr",
      "logo": {
        "@type": "ImageObject",
        "url": "https://724lastik.com.tr/images/hero/slide1.webp",
      },
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Anasayfa", "item": "https://724lastik.com.tr/" },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://724lastik.com.tr/blog" },
      { "@type": "ListItem", "position": 3, "name": post.title },
    ],
  };

  const blogTitle = post.title + ' | 7/24 Lastik Kocaeli';

  return (
    <Helmet>
      <title>{blogTitle}</title>
      <meta name="description" content={post.excerpt} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={blogTitle} />
      <meta property="og:description" content={post.excerpt} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={blogTitle} />
      <meta name="twitter:description" content={post.excerpt} />
      <meta name="twitter:image" content={fullImage} />
      <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </Helmet>
  );
}

// Separate component for FAQ schema to avoid Helmet children issues
export function FAQSchema({ content }) {
  if (!content) return null;
  const faqItems = [];
  const faqRegex = /<p class="faq-q">(.*?)<\/p>\s*<p class="faq-a">(.*?)<\/p>/g;
  let match;
  while ((match = faqRegex.exec(content)) !== null) {
    faqItems.push({ question: match[1], answer: match[2] });
  }
  if (faqItems.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": { "@type": "Answer", "text": item.answer }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

// Local Business Schema for homepage
export function LocalBusinessSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "7/24 Lastik Yol Yardım",
    "description": BASE_DESC,
    "url": "https://724lastik.com.tr",
    "telephone": "+905349687611",
    "email": "info@724lastik.com.tr",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Kocaeli",
      "addressRegion": "Kocaeli",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.776044",
      "longitude": "29.709975"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "areaServed": [
      "İzmit","Gebze","Darıca","Körfez","Gölcük","Derince",
      "Çayırova","Kartepe","Başiskele","Karamürsel","Kandıra","Dilovası"
    ],
    "priceRange": "₺₺",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "340"
    }
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Lastik Yol Yardım",
    "provider": {
      "@type": "LocalBusiness",
      "name": "7/24 Lastik Yol Yardım",
      "telephone": "+905349687611",
    },
    "areaServed": {
      "@type": "State",
      "name": "Kocaeli",
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Lastik Yol Yardım Hizmetleri",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Acil Lastik Tamiri" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Lastik Değişimi" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Sibop Tamiri" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Stepne Hizmeti" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Jant Onarımı" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Zincir Takma" } },
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
    </Helmet>
  );
}

// BreadcrumbList Schema for any page
export function BreadcrumbSchema({ items }) {
  if (!items || items.length === 0) return null;
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": item.url ? `https://724lastik.com.tr${item.url}` : undefined,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

// WebSite schema for sitelinks search box in Google
export function WebSiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "7/24 Lastik Yol Yardim",
    "url": "https://724lastik.com.tr",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://724lastik.com.tr/blog?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "7/24 Lastik Yol Yardim",
    "url": "https://724lastik.com.tr",
    "logo": "https://724lastik.com.tr/images/hero/slide1.webp",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+905349687611",
      "contactType": "customer service",
      "areaServed": "TR",
      "availableLanguage": "Turkish",
    },
    "sameAs": [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
    </Helmet>
  );
}

// District-specific SEO schemas (LocalBusiness + FAQPage + BreadcrumbList)
export function DistrictSEOSchemas({ district }) {
  if (!district) return null;

  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `7/24 Lastik — ${district.name} Lastik Yol Yardım`,
    "description": district.metaDesc,
    "url": `https://724lastik.com.tr/${district.slug}`,
    "telephone": "+905349687611",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": district.name,
      "addressRegion": "Kocaeli",
      "addressCountry": "TR",
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59",
    },
    "priceRange": "₺₺",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "340",
    },
  };

  const faqSchema = district.faqs && district.faqs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": district.faqs.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a },
    })),
  } : null;

  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Anasayfa", "item": "https://724lastik.com.tr/" },
      { "@type": "ListItem", "position": 2, "name": "Acil Yol Yardım", "item": "https://724lastik.com.tr/acil-yol-yardim" },
      { "@type": "ListItem", "position": 3, "name": `${district.name} Lastik Yol Yardım` },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>
      {faqSchema && <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>}
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
  );
}
